import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import slide1 from "../Images/history.jpg";
import slide2 from "../Images/opentosky.jpg";
import slide3 from "../Images/h8.jpeg";
import slide4 from "../Images/photo0jpg.jpg";
import slide5 from "../Images/silderhome4.jpg";
import slide6 from "../Images/night-view-from-food.jpg";
import slide8 from "../Images/mughal.jpeg";
import slide9 from "../Images/garden3.jpeg";
import slide10 from "../Images/grden2.jpeg";

const slidesData = [
  { image: slide1, caption: "Historic Walled City Views", tag: "Iconic Badshahi Mosque" },
  { image: slide2, caption: "Open Sky Dining Under The Stars", tag: "Rooftop Romance" },
  { image: slide3, caption: "Mughal Architecture & Royal Ambience", tag: "Living Heritage" },
  { image: slide4, caption: "Authentic Masterful Lahori Cuisine", tag: "Flavours of Punjab" },
  { image: slide5, caption: "Unforgettable Celebrations & Banquets", tag: "Grand Festivities" },
  { image: slide6, caption: "Evening Magic at Fort Road Food Street", tag: "Golden Hour Glow" },
  { image: slide8, caption: "Royal Heritage Dining Rooms", tag: "Imperial Elegance" },
  { image: slide9, caption: "Haveli Courtyard Garden Serenity", tag: "Lush & Peaceful" },
  { image: slide10, caption: "Centuries of Culture Preserved with Care", tag: "Timeless Tradition" },
];

const HomeBanner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const numOfSlides = slidesData.length;

  const goToSlide = (index) => {
    let next = index;
    if (next < 0) next = numOfSlides - 1;
    if (next >= numOfSlides) next = 0;
    setActiveIndex(next);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1 >= numOfSlides ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(interval);
  }, [numOfSlides]);

  return (
    <section className="slider hero-slider royal-hero" aria-label="Hero slideshow">
      <div className="slider__slides">
        {slidesData.map((slide, index) => {
          const isActive = index === activeIndex;
          return (
            <div
              key={index}
              className={`slide ${isActive ? "s--active royal-slide--active" : ""}`}
              style={{ backgroundImage: `url(${slide.image})` }}
              aria-hidden={!isActive}
            >
              <div className="slide__inner royal-slide__inner">
                <div className="slide__content">
                  <div className="hero-content royal-hero-content">
                    {/* Royal emblem & tag */}
                    <div className="royal-hero-badge">
                      <span className="royal-hero-badge__icon">✦</span>
                      <span className="royal-hero-badge__text">{slide.tag}</span>
                      <span className="royal-hero-badge__icon">✦</span>
                    </div>

                    <h1 className="hero-title royal-hero-title">
                      <span className="royal-hero-title__main">Haveli</span>
                      <span className="royal-hero-title__sub">Restaurant</span>
                    </h1>

                    <div className="royal-hero-divider">
                      <span className="royal-line" />
                      <span className="royal-crest">⚜</span>
                      <span className="royal-line" />
                    </div>

                    <p className="hero-caption royal-hero-caption">{slide.caption}</p>
                    
                    <p className="hero-subtitle royal-hero-subtitle">
                      Fine dining in the heart of Lahore’s Walled City — where Mughal grandeur, timeless history &amp; unforgettable flavours unite.
                    </p>

                    <div className="hero-actions royal-hero-actions">
                      <Link to="/menu" className="hero-btn hero-btn--primary royal-btn-shimmer">
                        <span>Explore Menu</span>
                        <span className="btn-arrow">→</span>
                      </Link>
                      <Link to="/contact" className="hero-btn hero-btn--outline royal-btn-outline">
                        <span>Book a Table</span>
                        <span className="btn-icon">✦</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Slide Index Pill */}
      <div className="royal-slide-counter">
        <span className="current">0{activeIndex + 1}</span>
        <span className="sep">/</span>
        <span className="total">0{numOfSlides}</span>
      </div>

      {/* Navigation Controls */}
      <button
        type="button"
        className="slider__control slider__control--left hero-nav-btn royal-nav-btn"
        aria-label="Previous slide"
        onClick={() => goToSlide(activeIndex - 1)}
      >
        <span aria-hidden="true">‹</span>
      </button>
      <button
        type="button"
        className="slider__control slider__control--right hero-nav-btn royal-nav-btn"
        aria-label="Next slide"
        onClick={() => goToSlide(activeIndex + 1)}
      >
        <span aria-hidden="true">›</span>
      </button>

      {/* Slide Navigation Dots (Separated cleanly from scroll indicator) */}
      <div className="hero-dots royal-hero-dots" role="tablist" aria-label="Slide navigation">
        {slidesData.map((_, index) => (
          <button
            key={index}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            aria-label={`Go to slide ${index + 1}`}
            className={`hero-dot royal-dot ${index === activeIndex ? "is-active" : ""}`}
            onClick={() => goToSlide(index)}
          >
            {index === activeIndex && <span className="royal-dot-fill" />}
          </button>
        ))}
      </div>

      {/* Scroll Indicator positioned properly below */}
      <a href="#welcome" className="hero-scroll royal-hero-scroll" aria-label="Scroll to content">
        <span className="hero-scroll__text">Discover Haveli</span>
        <span className="hero-scroll__mouse">
          <span className="hero-scroll__wheel" />
        </span>
      </a>
    </section>
  );
};

export default HomeBanner;
